import axios from 'axios';

const staticPrefix = __webpack_public_path__ || '/'; // 设置一个默认值

const versionUrl = `${staticPrefix}static/version.json`;

const getVersionFromServer = async () => {
  try {
    const response = await axios.get(versionUrl);
    return response.data.version;
  } catch (error) {
    throw error;
  }
};

export { getVersionFromServer };



// WEBPACK FOOTER //
// ./src/common/js/http_version.js